import { useMutation } from '@apollo/client';
import React, { useEffect, useRef, useState } from 'react';
import { FaRegCopy } from 'react-icons/fa';
import Modal from 'react-responsive-modal';
import { FILE_SHARE_LINK_CREATE, FILE_SHARE_LINK_REMOVE } from '../../../apollo/Mutations';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { setActiveFile, setPopup } from '../../../redux/messageSlice';

const FileSharePopup = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false)
    const [linkCreate, setLinkCreate] = useState(false);
    const [url, setUrl] = useState('');
    const linkCopyRef = useRef(null);
    const { active_file, linkShare_popup } = useSelector(state => state.message)
    console.log("🚀 ~ FileSharePopup ~ active_file:", active_file)
    let full_url = window.location.origin;

    // const closeIcon = <MdClose className="text-2xl mt-1 text-teal-600 " />;
    const closeIcon = <div className="privateCloseIcon text-2xl mt-1 text-teal-600 " />;

    useEffect(() => {
        if (active_file?.url_short_id && active_file?.url_short_id !== '') {
            setUrl(full_url + '/f/' + active_file?.url_short_id);
            setLinkCreate(true);
        }
    }, [])

    const handleClosePopup = () => {
        dispatch(setPopup({ key: 'linkShare_popup', value: false }))
        dispatch(setActiveFile(null))
    }

    const [createLink] = useMutation(FILE_SHARE_LINK_CREATE)
    const CreateNewLink = async () => {
        setLoader(true)
        try {
            let res = await createLink({
                variables: {
                    input: {
                        file_id: active_file.id,
                        participants: active_file.participants
                    }
                }
            });

            setLoader(false)
            console.log("🚀 ~ CreateNewLink ~ res:", res)
            setUrl(full_url + '/f/' + res.data.file_share_link_create);
            setLinkCreate(true);
        } catch (error) {
            setLoader(false)
            console.log(error)
        }
    }

    const copyLink = () => {
        linkCopyRef.current.select()
        document.execCommand("copy");
        toast.success('Copied to clipboard', { duration: 4000 });
        dispatch(setPopup({ key: 'linkShare_popup', value: false }))
        // navigator.clipboard.writeText(shareableLink);
    }

    const [removeLink] = useMutation(FILE_SHARE_LINK_REMOVE)
    const removeShare = async () => {

        try {
            let res = await removeLink({
                variables: {
                    input: {
                        file_id: active_file?.id,
                        participants: active_file?.participants
                    }
                }
            });
            console.log("🚀 ~ removeShare ~ res:", res);

            toast.success('Shared link has been removed from the file successfully.', {
                style: {
                    fontSize: '14px',
                    maxWidth: '520px'
                },
                duration: 3000
            });
            dispatch(setActiveFile(null))
            dispatch(setPopup({ key: 'linkShare_popup', value: false }))
        } catch (error) {
            console.log("🚀 ~ removeShare ~ error:", error)
        }
    }


    return (
        <Modal
            open={linkShare_popup}
            onClose={handleClosePopup}
            center
            closeIcon={closeIcon}
            focusTrapped={false}
            classNames={{
                overlay: 'customOverlay',
                modal: 'customModal',
            }}
        >
            <div className="">
                <h2 className="text-xl text-teal-600">Share</h2>
                <div>
                    <p className="pt-5 pb-5 text-grey-600 text-sm text-justify">Create a shareable url/link and simply paste the link in any channel to share the file with anyone. You can always disable shareable link anytime.</p>
                    {
                        linkCreate &&
                        <div className="conf_input relative w-full pb-5">
                            <span className="copy_confLink absolute top-1/2 -translate-y-1/2 right-3 cursor-pointer" onClick={copyLink}>
                                <FaRegCopy style={{ color: '#65ABA6' }} />
                            </span>
                            <input
                                className="topicInputs w-full pr-10 pl-2"
                                type="text"
                                placeholder="File share Url"
                                style={{ textIndent: '0px' }}
                                ref={linkCopyRef}
                                value={url}
                                readOnly
                            />
                        </div>
                    }
                </div>

                {
                    linkCreate ?
                        <div className="flex justify-end gap-2.5">
                            <button className="px-4 py-2 bg-red-500 text-sm text-white rounded-md" onClick={removeShare}>Remove Link</button>
                            <button className="px-4 py-2 bg-teal-600 text-sm text-white rounded-md" onClick={copyLink}>Copy</button>
                        </div>
                        :
                        <div className="flex justify-end gap-2.5">
                            <button className={`px-4 py-2 bg-teal-600 text-sm text-white rounded-md ${loader ? 'pointer-events-none' : ''}`} onClick={CreateNewLink}>{loader ? 'Processing...' : 'Create Link'}</button>
                        </div>
                }
            </div>
        </Modal>
    );
};

export default FileSharePopup;